// extracted by mini-css-extract-plugin
module.exports = {"container-5050":"Container5050_container-5050__9r5FU","container-5050__col":"Container5050_container-5050__col__nWZRa"};